import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';
import { applyCypressData } from 'Utilities/helpers';

import { PriceAndSaleInfo } from '../PriceAndSaleInfo/PriceAndSaleInfo';
import { useBiddingSection } from '../useBiddingSection';

import { PostSaleCTA } from './PostSaleCTA';
import soldTexts from './Sold.texts';

import styles from './Sold.module.scss';

const LocalT = new MDText(soldTexts);

export const Sold: React.FC = () => {
	const { hasDealershipWonVehicleAndSellerConfirmed, soldDate } = useBiddingSection();

	const {
		minWidth: { breakpointTablet: isDesktop },
	} = useBreakpoint();

	const shouldShowPostSaleCTASection = isDesktop && hasDealershipWonVehicleAndSellerConfirmed;

	return (
		<>
			<PriceAndSaleInfo badgeVariant="sold" />
			{soldDate ? (
				<div className={styles.soldDateContainer}>
					<span>{LocalT.translate('soldDate')}</span>
					<span className={styles.date} {...applyCypressData(cypressIds.text.sidebarSoldDate)}>
						{soldDate}
					</span>
				</div>
			) : null}
			{shouldShowPostSaleCTASection ? <PostSaleCTA /> : null}
		</>
	);
};
